import React, { useState } from "react";
import { Box, TextField, Button, Grid, Typography, Container, Paper } from "@mui/material";
import { FormattedMessage } from "react-intl";
import emailjs from "emailjs-com";

const ContactUs: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  
    try {
      const result = await emailjs.send(
        "service_mln7xrh", // service id
        "template_23vc1rq", // template id
        {
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
        },
        "B3gdCPqgwdhc8EBQS" // user id
      );
  
      if (result.status === 200) {
        alert("Your message has been sent successfully!");
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        alert("Failed to send your message. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ padding: 4, marginTop: 4 }}>
        <Typography variant="h4" gutterBottom>
          <FormattedMessage id="contactUs.title" />
        </Typography>
        <Typography variant="body1" gutterBottom>
          <FormattedMessage id="contactUs.description" />
        </Typography>
        <Box sx={{ marginTop: 3 }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={<FormattedMessage id="contactUs.form.name" />}
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={<FormattedMessage id="contactUs.form.email" />}
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  type="email"
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={<FormattedMessage id="contactUs.form.subject" />}
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={<FormattedMessage id="contactUs.form.message" />}
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  multiline
                  rows={4}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <Button type="submit" fullWidth variant="contained" color="primary">
                  <FormattedMessage id="contactUs.form.submit" />
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
        <Box sx={{ marginTop: 4 }}>
          <Typography variant="h6">
            <FormattedMessage id="contactUs.contactInfo.title" />
          </Typography>
          <Typography variant="body1">
            <FormattedMessage id="contactUs.contactInfo.email" values={{ email: "coreyjjohnson90@gmail.com" }} />
          </Typography>
          <Typography variant="body1">
            <FormattedMessage id="contactUs.contactInfo.phone" values={{ phone: "+358445001976" }} />
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default ContactUs;